const noScroll = (e) => {
	e.preventDefault()
}

window.addEventListener('load', () => {
	const mvSwiper = new Swiper('.mv_swiper', {
		direction: 'horizontal',
		loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
		// effect: 'creative',
		// creativeEffect: {
		// 	prev: {
		// 		shadow: true,
		// 		opacity: 1
		// 		// translate: [0, '10%', 0],
		// 	},
		// 	next: {
		// 		translate: [0, '10%', 0],
		// 		opacity: 0
		// 	},
		// },
		autoplay: {
			delay: 5000
		},
		allowTouchMove: false,
		speed: 600
	});

  // オープニングムービー 制御
  const openingMovieWrap = document.querySelector('.opening_animation_wrap')
  const openingMovieVideo = openingMovieWrap.querySelector('video')

  if (!window.sessionStorage.getItem('played_opening')) {
    document.addEventListener('touchmove', noScroll, {passive: false});
    document.addEventListener('wheel', noScroll, {passive: false});

    openingMovieVideo.play()

    openingMovieWrap.querySelector('video').addEventListener('ended', () => {
      openingMovieWrap.style.opacity = '0'
      openingMovieWrap.style.visibility = 'hidden'

      document.removeEventListener('touchmove', noScroll);
      document.removeEventListener('wheel', noScroll);

      window.sessionStorage.setItem(['played_opening'],[true]);
    })
  } else {
    openingMovieVideo.style.display = 'none'
    openingMovieWrap.style.transition = '.5s'
    openingMovieWrap.style.opacity = '0'
    openingMovieWrap.style.visibility = 'hidden'
  }


	// MV商品紹介制御
	let nowPercentage = 0

	const mvProductsTrack = document.querySelector('.mv_products_slider_inner')

	generateLoopSlider(mvProductsTrack, '#prev_btn', '#next_btn')

	const bars = document.querySelectorAll('.count_down_bar')
	const sec = 5
	const rate = 10

	const ms = sec * 1000
	const percentagePerInterval = 100 / (ms / rate)

	const CDInt = setInterval(() => {
		nowPercentage += percentagePerInterval

		bars.forEach(elm => elm.style.background = `linear-gradient(to right, white ${nowPercentage}%, #493959 ${nowPercentage}% 100%)`)

		if (nowPercentage >= 100) {
			nowPercentage = 0
			mvProductsTrack.scrollTo({
				left: mvProductsTrack.scrollLeft + mvProductsTrack.children[0].clientWidth
			})
		}
	}, rate)

	mvProductsTrack.addEventListener('scrollend', () => {
		nowPercentage = 0

		const pageNumberElm = document.querySelector('.mv_products_slider_pager span')
		const scrolledPages = Math.floor(mvProductsTrack.scrollLeft / mvProductsTrack.children[0].clientWidth)

		if (!scrolledPages || scrolledPages === 3) {
			pageNumberElm.innerText = '01'
		} else if (scrolledPages === 1 || scrolledPages === 4) {
			pageNumberElm.innerText = '02'
		} else if (scrolledPages === 2 || scrolledPages === 5) {
			pageNumberElm.innerText = '03'
		}
	})

  // 帯スライダー
  const obiSliderInner = document.querySelector('.top_about_obi_slider_inner')

  Array.from(obiSliderInner.children).forEach(elm => {
    const clone = elm.cloneNode(true)
    obiSliderInner.appendChild(clone)
  })
})